import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";

export default function GalleryPage() {
  const [data, setData] = useState(null);
  useEffect(() => { http.get("/public/property").then((r) => setData(r.data)); }, []);
  if (!data) return null;
  return (
    <div>
      <PublicHeader />
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-16">
        <div className="eyebrow mb-3">Gallery</div>
        <h1 className="h1-hero text-5xl md:text-6xl mb-10">Moments at the villa</h1>
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 space-y-4">
          {data.gallery.map((g, i) => (
            <img key={g.id} src={g.image_url} alt={g.alt_text} data-testid={`gallery-img-${i}`} className="w-full rounded-xl mb-4 break-inside-avoid" />
          ))}
        </div>
      </div>
      <PublicFooter />
    </div>
  );
}
